// src/sections/HowWeWork.js
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FiFlag, FiMap, FiCode, FiSend } from "react-icons/fi";
import "./HowWeWork.css";

function HowWeWork() {
  const { t } = useTranslation();

  const steps = [
    { icon: <FiFlag />, title: t("process.kickoff.title"), desc: t("process.kickoff.desc") },
    { icon: <FiMap />,  title: t("process.planning.title"), desc: t("process.planning.desc") },
    { icon: <FiCode />, title: t("process.development.title"), desc: t("process.development.desc") },
    { icon: <FiSend />, title: t("process.delivery.title"), desc: t("process.delivery.desc") },
  ];

  return (
    <section className="process-section" id="process">
      <div className="process-container">
        <motion.div
          className="process-headline"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        ><div className="process-headline">
  {/* Replace eyebrow with a proper H2 to match other sections */}
  <h2>{t("process.sectionTitle") /* e.g., "How We Work" */}</h2>
  <p className="lead">{t("process.title") /* keep your big sentence here */}</p>
</div>
        </motion.div>

        <div className="process-track">
          <span className="process-line" aria-hidden />
          {steps.map((s, i) => (
            <motion.div
              key={i}
              className="process-card"
              initial={{ opacity: 0, y: 30, scale: 0.98 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
            >
              <div className="icon-wrap">
                <span className="icon">{s.icon}</span>
                <span className="dot" />
              </div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="process-cta"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <a className="process-button" href="/contact">
            {t("process.cta")}
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default HowWeWork;